import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { getJson } from '@hcr/api/shared'

import type { ErrorDto } from '../../dtos'
import type { HeroDto } from '../../dtos/responses/views'
import { HeroDtoSchema } from '../../dtos/responses/views'

export const createHeroQueryKey = (params: HeroQueryParams) => ['optimizely', 'hero', params]

interface HeroQueryParams {
  isOwner: boolean
}

export const createHeroQuery =
  (baseUrl: string) =>
  <Data = HeroDto>(params: HeroQueryParams, options?: Partial<UseQueryOptions<HeroDto, ErrorDto, Data>>) =>
    useQuery<HeroDto, ErrorDto, Data>({
      ...options,
      queryKey: createHeroQueryKey(params),
      queryFn: () =>
        getJson({
          schema: HeroDtoSchema,
          url: `${baseUrl}/hero-element?isOwner=${params.isOwner}`,
        }),
    })
